import { render, staticRenderFns } from "./BuildinLayoutTopLeft.vue?vue&type=template&id=1a00fd06&scoped=true&"
import script from "./BuildinLayoutTopLeft.vue?vue&type=script&lang=ts&"
export * from "./BuildinLayoutTopLeft.vue?vue&type=script&lang=ts&"
import style0 from "./BuildinLayoutTopLeft.vue?vue&type=style&index=0&id=1a00fd06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a00fd06",
  null
  
)

export default component.exports